import styles from "./index.module.css";
import { useEffect, useRef } from "react";
const TheMatch = (props) => {
  const svgRef = useRef(null);
  useEffect(() => {
    svgRef.current.querySelectorAll("path").forEach((element) => {
        element.style.setProperty("--effect-path-length", `${element.getTotalLength()}px`);
    });
  }, []);
  return (
    <svg
      ref={svgRef}
      width="1023"
      height="244"
      viewBox="0 0 1023 244"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${styles.svg} ${props.className}`}
    >
      <path
        d="M414 150.436C464.5 154.001 596.99 77.1967 641 35.0011C689.5 -11.4989 594 112.067 564.5 174.001C545.35 214.207 674.5 94.5655 745 24.5C786.921 -17.1624 682.5 141 645 214.5"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M772.045 116.52C754.841 114.033 730.869 121.233 724.732 137.042C717.973 154.455 759.757 133.935 778.191 111.545C797.5 88.0934 777.854 120.128 774.5 128.003C763 155.003 806 141.081 813 128.003C820 114.924 864.5 45.5025 882 20.5025C859.333 53.6692 812.6 124.802 807 144.002C800 168.002 823.593 165.503 870 128.003C912.5 83.5 908 128.243 908 116.52C908 101.5 884 107 868 131.5C849.169 160.334 920 138.5 935.5 130.5C942.5 119.5 994.5 32.5008 1020 4.00079C1028.69 -5.71598 978 53.9992 923.5 154C904.57 188.734 951.657 127.348 976 115C1010.5 97.5 947 177.5 1018.5 132.003"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M2 33.9989C73 31.5002 249 35.5012 322 32"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M803 57C877.5 60 946 58 981.5 55"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M164.5 25C135.5 55 47 200.5 24 242"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M235 4.5C212 32.5 103 198.5 142.5 157.5C182 116.5 208.216 92.8523 197.5 135C190 164.5 224 131.305 238 130C294.5 124.733 259.5 100.5 238 125C221.76 143.507 250 156 302.5 132.5"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
    </svg>
  );
};

export default TheMatch;
